

export const contactUsData = [
  {
    id: 1,
    heading: '📬 General Inquiries',
    paragrafh: 'Have a question or need more info about our platform?',
    email: 'sales@spatialgrid.ai',
  },
  {
    id: 2,
    heading: '🤝 Partnerships & Collaboration',
    paragrafh:
      'Looking to collaborate on a project or integrate with our platform?',
    email: 'sales@spatialgrid.ai',
  },
  {
    id: 3,
    heading: '📰 Press & Media',
    paragrafh:
      'Interested in featuring Spatial Grid or speaking with our leadership team?',
    email: 'info@spatialgrid.ai',
  },
  {
    id: 4,
    heading: '🛡️ Security & Compliance',
    paragrafh: 'Have a question or need more info about our platform?',
    email: 'info@spatialgrid.ai',
  },
  {
    id: 5,
    heading: '🌐 Visit Us',
    paragrafh: 'Unit 4-B1, 4th Floor, G-Square Raidurgam, Gachibowli HYDERABAD, TELANGANA 500102 India.',
  },
];
